import React, {useState, useRef, useLayoutEffect, useEffect} from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { chatList } from 'modules/actions/chat';
import { imageData } from 'components/molecules/MessageTemplateSet/BotMessage/imageData';
import IconButton from 'components/atoms/Button/IconButton';
import {
  SimpleMessage,
  TextMessage,
  ButtonMessage,
  ImageButtonMessage,
  MediaMessage,
  ImageMessage,
  BigCard,
  ListImageCard,
  ListBtnCard,
  ListBtnCardAdv,
  ListBtnCardArray,
  ListBtn,
  StatListBtn,
  FieldListBtn,
  SmallCard,
  IntroButton,
  AdministrativeMap,
  CivilissuanceMap,
  ToiletMap,
} from 'components/molecules/MessageTemplateSet/Templates/index';
import { isACtiveSatisfyModal, isActiveFeedbackModal, isActiveComplaintModal, loading, isActiveUsabilityModal } from 'modules/actions/statusMenu';
import { setMessageId, setClickedBotMessage } from 'modules/actions/quality';
/**
 * BotMessage
 */
const BotMessage = ({ boxStyle, item, responseType, index }) => {
  const dispatch = useDispatch();
  const isQualitySend = useSelector(state => state.chatList.data[index].isQualitySend);
  const domainUrlParam = process.env.REACT_APP_DOMAIN_URL;
  // const isQualitySend = useSelector(state => state.chatList.data[index].isQualitySend);
  const intro = 'intro';
  const onSendMessage = (inStr, inType, inLabel) => {

    if (inType !== 'url') {
      if (inStr === 'task_Location_Allow_Y') {
        getLocation(inStr, inType, inLabel);
      } else if (inStr === 'task_Location_Allow_N') {
        const paramSet = {
          inType: inType || 'param',
          inStr,
          inLabel,
          parameters: { latitude_y: '37.275856', longitude_x: '127.151277', position_status: 'Y', address: '경기 용인시 기흥구 동백5로 22' },
        };
        dispatch(chatList(paramSet));
      } else if (inStr === '처인구') {
        const paramSet = {
          inType: inType || 'param',
          inStr,
          inLabel,
          parameters: { latitude_y: '37.234164', longitude_x: '127.201348', position_status: 'Y', address: '용인시 처인구 금령로 50' },
        };
        dispatch(chatList(paramSet));
      } else if (inStr === '기흥구') {
        const paramSet = {
          inType: inType || 'param',
          inStr,
          inLabel,
          parameters: { latitude_y: '37.280208', longitude_x: '127.114680', position_status: 'N', address: '용인시 기흥구 관곡로 95' },
        };
        dispatch(chatList(paramSet));
      } else if (inStr === '수지구') {
        const paramSet = {
          inType: inType || 'param',
          inStr,
          inLabel,
          parameters: { latitude_y: '37.322159', longitude_x: '127.097702', position_status: 'N', address: '용인시 수지구 포은대로 435' },
        };
        dispatch(chatList(paramSet));
      } else {
        const paramSet = {
          inType: inType || 'query',
          inStr,
          inLabel,
          parameters: sessionStorage.getItem('address')
            ? {
                latitude_y: sessionStorage.getItem('latitude_y'),
                longitude_x: sessionStorage.getItem('longitude_x'),
                address: sessionStorage.getItem('address'),
                position_status: 'Y',
              }
            : { latitude_y: '', longitude_x: '', position_status: 'N' },
        };
	const inputBox = document.getElementById('_send_box_input');
        inputBox.setAttribute('readonly', 'true'); // readonly로 설정하여 키보드 방지
        inputBox.focus();
        setTimeout(() => {
        inputBox.removeAttribute('readonly'); // 포커스가 설정된 후 readonly를 제거
        }, 0);
        dispatch(chatList(paramSet));
      }
    } else {
      window.open(inStr.replace(/&amp;/g, '&'));
    }
  };

  function getLocation(inStr, inType, inLabel) {
    dispatch(loading(true));
    const options = {
      // 가능한 경우, 높은 정확도의 위치(예를 들어, GPS 등) 를 읽어오려면 true로 설정
      // 그러나 이 기능은 배터리 지속 시간에 영향을 미친다.
      enableHighAccuracy: true, // 대략적인 값이라도 상관 없음: 기본값

      // 위치 정보가 충분히 캐시되었으면, 이 프로퍼티를 설정하자,
      // 위치 정보를 강제로 재확인하기 위해 사용하기도 하는 이 값의 기본 값은 0이다.
      maximumAge: 180000, // 3분이 지나기 전까지는 수정되지 않아도 됨

      // 위치 정보를 받기 위해 얼마나 오랫동안 대기할 것인가?
      // 기본값은 Infinity이므로 getCurrentPosition()은 무한정 대기한다.
      timeout: 5000, // 5초 이상 기다리지 않는다.
    };

    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition(
        function success(pos) {
          const latitude_y = pos.coords.latitude;
          const longitude_x = pos.coords.longitude;
          sessionStorage.setItem('latitude_y', latitude_y);
          sessionStorage.setItem('longitude_x', longitude_x);
          new window.kakao.maps.services.Geocoder().coord2Address(longitude_x, latitude_y, function (result, status) {
            if (status === window.kakao.maps.services.Status.OK) {
              sessionStorage.setItem('address', result[0].address.region_3depth_name);
              /* global parameter */
              const paramSet = {
                inType,
                inStr,
                inLabel,
                parameters: {
                  latitude_y,
                  longitude_x,
                  position_status: 'Y',
                  address: result[0].address.region_3depth_name || sessionStorage.getItem('address'),
                },
              };
              dispatch(chatList(paramSet));
              setTimeout(() => {
                sessionStorage.removeItem('latitude_y');
                sessionStorage.removeItem('longitude_x');
                sessionStorage.removeItem('address');
              }, 180000);
            }
          });
        },
        function error(e) {
          const paramSet = {
            inType: 'param',
            inStr: 'task_Location_Allow_N',
            inLabel: '동의 안 함',
            parameters: { latitude_y: '', longitude_x: '', position_status: 'N' },
          };
          dispatch(chatList(paramSet));
        },
        options
      );
    } else {
      alert('Geolocation is not supported by this browser.');
    }
  }

  const makeKeyVal = (id, idx) => `bot_${id}_${idx}`;

  const setSimpleItem = (message, idx) => {
    if (message.text) {
      return <SimpleMessage idx={idx} key={makeKeyVal('simple', idx)} item={message} boxStyle={boxStyle} />;
    }
    return false;
  };

  const setTemplateItem = (tempItem, idx) => {
    const { id } = tempItem;
    const key = makeKeyVal(id, idx);

    // console.log(JSON.stringify(tempItem,null,2))
    // console.log("key : "+key)


    let widthContent = id === 'small_card' ? 230 : 470;
    if (window.innerWidth < 500) {
      widthContent = id === 'small_card' ? 168 : 290;
    }

    if (id === 'textbox') {
      return <TextMessage key={key} item={tempItem} boxStyle={boxStyle} />;
    }

    if (id === 'quick_btn') {
      if (chatMsgDiv.current && idx < 1) {
        return <ButtonMessage key={key} item={tempItem} onClickEvt={onSendMessage} boxStyle={boxStyle} />;
      }
      return <ButtonMessage key={key} item={tempItem} onClickEvt={onSendMessage} boxStyle={boxStyle} />;
    }

    if (id === 'image') {
      return <ImageMessage key={key} item={tempItem} />;
    }

    if (id === 'image_btn') {
      return <ImageButtonMessage key={key} item={tempItem} onClickEvt={onSendMessage} boxStyle={boxStyle} />;
    }

    if (id === 'intro_btn') {
      return <IntroButton key={key} item={tempItem} onClickEvt={onSendMessage} boxStyle={boxStyle} viewStatus={intro} />;
    }

    if (id === 'media') {
      return <MediaMessage key={key} item={tempItem} />;
    }

    if (id === 'big_card') {
      return <BigCard key={key} item={tempItem} onClickEvt={onSendMessage} boxStyle={{ width: widthContent, margin: 4.5, height: '410px' }} />;
    }

    if (id === 'complaints_tem') {
      // console.log("delete bot Message");
    }

    if (id === 'list_image_card') {
      return <ListImageCard key={key} item={tempItem} onClickEvt={onSendMessage} boxStyle={{ width: widthContent, margin: 4.5, height: '410px' }} />;
    }

    if (id === 'small_card') {
      return <SmallCard key={key} item={tempItem} onClickEvt={onSendMessage} boxStyle={{ width: widthContent, margin: 4.5, height: '230px' }} />;
    }

    if (id === 'list_btn_card') {
      return <ListBtnCard key={key} item={tempItem} onClickEvt={onSendMessage} boxStyle={boxStyle} slideBoxSet={{ width: widthContent, margin: 4.5, height: '280px' }} />;
    }

    if (id === 'list_btn_card_adv') {
      return <ListBtnCardAdv key={key} item={tempItem} onClickEvt={onSendMessage} boxStyle={boxStyle} slideBoxSet={{ width: widthContent, margin: 4.5, height: '280px' }} />;
    }

    if (id === 'list_btn_card_array') {
      return <ListBtnCardArray key={key} item={tempItem} onClickEvt={onSendMessage} boxStyle={boxStyle} slideBoxSet={{width: widthContent, margin: 4.5, height: '280px' }} />;
    }

    if (id === 'list_btn') {
      return <ListBtn key={key} item={tempItem} onClickEvt={onSendMessage} boxStyle={boxStyle} />;
    }

    if (id === 'list_btn_stat') {
      return <StatListBtn key={key} item={tempItem} onClickEvt={onSendMessage} boxStyle={boxStyle} msgIndex={index} />;
    }

    if (id === 'list_btn_field') {
      return <FieldListBtn key={key} item={tempItem} onClickEvt={onSendMessage} boxStyle={boxStyle} msgIndex={index} />;
    }

    if (id === 'administrative_tem') {
      return <AdministrativeMap key={key} item={tempItem} />;
    }

    if (id === 'civilissuance_tem') {
      return <CivilissuanceMap key={key} item={tempItem} boxStyle={boxStyle} />;
    }

    if (id === 'toilet_tem') {
      return <ToiletMap key={key} item={tempItem} boxStyle={boxStyle} />;
    }

    // if (id === 'card_extend') {
    //   return <CardExtend key={key} item={tempItem} boxStyle={{ width: 180, margin: 10, height: '240px' }} />;
    // }
    // if (id === 'custom') {
    //   return <CustomerMessage item={item} />;
    // }

    return false;
  };

  let logo_url = imageData.normal;
  switch (item.emotion) {
    case 'normal':
      logo_url = imageData.normal;
      break;
    case 'love':
      logo_url = imageData.love;
      break;
    case 'sad':
      logo_url = imageData.sad;
      break;
    case 'confuse':
      logo_url = imageData.confuse;
      break;
    case 'intro':
      logo_url = imageData.intro;
      break;
    default:
      logo_url = imageData.normal;
      break;
  }

  // (1). IconButton 클릭 시, 마지막으로 클릭한 bot_message 상태 action 으로 저장.
  const handleClicked = (e) => {
    const clickedElement = e.target.closest('div[name^="bot_"]');
    const botMessage = clickedElement.getAttribute('name'); // bot_1
    dispatch(setClickedBotMessage(botMessage))
  };

  // (2). Modal 열 때, handleClicked(e) 실행 추가.
  const openSatisfyModal = (e) => {
    handleClicked(e);
    dispatch(setMessageId(item.id));
    dispatch(isACtiveSatisfyModal({
      isSequential: false
      }
    ));
  };

  const openFeedbackModal = (e) => {
    handleClicked(e)
    dispatch(setMessageId(item.id));
    dispatch(isActiveFeedbackModal());
  };

  const openUsabilityModal = (e) => {
    dispatch(setMessageId(item.id));
    dispatch(isActiveUsabilityModal(true));
  };

  const [msgBtm, setMsgBtm] = useState(498);
  const chatMsgDiv = useRef();

  let msgBtmStyle = {};
  let cardUseState;

  if (item?.templateMessages) {
    cardUseState = item?.templateMessages.find(ele => {
      if (ele.id.includes('_card') || ele.id.includes('_btn')) {
        return true;
      }
      return false;
    });
  }

  if (cardUseState) {
    msgBtmStyle = { width: '100%', maxWidth: 'fit-content', outline: 'none' };
  } else {
    msgBtmStyle = { display: 'table', outline: 'none' };
  }

  useLayoutEffect(() => {
    setMsgBtm(chatMsgDiv?.current?.clientWidth);

    function handleResize(a) {
      setMsgBtm(chatMsgDiv?.current?.clientWidth);
    }

    if (item?.templateMessages) {
      item?.templateMessages.forEach((data, idx) => {
        if (
          data.id === 'image_btn' ||
          data.id === 'list_image_card' ||
          data.id === 'big_card' ||
          data.id === 'small_card' ||
          data.id === 'list_btn_card' ||
          data.id === 'list_btn_card_adv' ||
          data.id === 'list_btn_card_array' ||
          data.id === 'list_btn' ||
          data.id === 'list_btn_stat' ||
          data.id === 'list_btn_field'
        ) {
          const inputBox = document.getElementById('_send_box_input');
	inputBox.setAttribute('readonly', 'true'); // readonly로 설정하여 키보드 방지
          inputBox.focus();
	setTimeout(() => {
        inputBox.removeAttribute('readonly'); // 포커스가 설정된 후 readonly를 제거
      }, 0);
        } else if (data.id === 'quick_btn' && idx < 1) {
          const inputBox = document.getElementById('_send_box_input');
          inputBox.focus();
        }
      });
    }
    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  });

  return (
    <div className="bot_message_div">
      <div className="_chat_name">
        <div className="_img" dangerouslySetInnerHTML={{ __html: logo_url }} />
        <span>조아용</span>
      </div>
      <div className="_chat_message">
        {item.response_status === 'loading' ? (
          <div className="_chat_message_set">
            <div className="_text_div">
              <div className="_message">
                <div className="loading">
                  <div className="ldio-er80fzh2vjb">
                    <div />
                    <div />
                    <div />
                    <div />
                    <div />
                  </div>
                </div>
              </div>
            </div>
            {item.createAt && (
              <div className="_chat_message_bottom">
                <div className="_chat_message_bottom_div">
                  <div className="_chat_time">{item.createAt}</div>
                </div>
              </div>
            )}
          </div>
        ) : (
          <>
            {/* <div className="_chat_message_set" ref={chatMsgDiv} style={msgBtmStyle} role="button" tabIndex={0}> */}
            <div className="_chat_message_set" ref={chatMsgDiv} style={msgBtmStyle}>
              {' '}
              {item?.messages?.map((message, idx) => {
                return setSimpleItem(message, idx);
              })}
              {item?.templateMessages?.map((tempItem, idx) => {
                return setTemplateItem(tempItem, idx);
              })}
            </div>
            {item.createAt && (
              <div className="_chat_message_bottom">
                <div className="_chat_message_bottom_div" style={{ width: msgBtm + 'px' }}>
                  <div className="_chat_time">{item.createAt}</div>
                  {item.response_status !== 'welcome' ? (
                    <div style={{ position: 'absolute' , left:'94px'}}>
                      <button
                        className="_chat_opinion"
                        type="button"
                        tabIndex="0"
			style={{ backgroundColor: 'white' }}
                        onClick={(e) => window.location.reload()}
                        onKeyPress={e => {
                          if (e.key === 'Enter') {
                            window.location.reload();
                          }
                        }}
                      ><img src={`/${domainUrlParam}/ibricks/images/home.png`} alt="" className="home" style={{ width: '23px', height: '23px' }}/>
			<span style={{ fontSize: '12px' }} >처음으로</span>
                      </button>
			  {/*
                      <button
                        className="_chat_opinion"
                        type="button"
                        tabIndex="0"
                        onClick={(e) => openFeedbackModal(e)}
                        onKeyPress={e => {
                          if (e.key === 'Enter') {
                            openFeedbackModal();
                          }
                        }}
                      >
                        의견남기기
                      </button>
			  <button
                        className="_chat_opinion"
                        type="button"
                        tabIndex="0"
                        onClick={(e) => openUsabilityModal(e)}
                      >
                        사용편의성조사
                      </button>
                      <button
                        className="_chat_opinion"
                        type="button"
                        tabIndex="0"
                        onClick={(e) => openSatisfyModal(e)}
                        onKeyPress={e => {
                          if (e.key === 'Enter') {
                            openSatisfyModal();
                          }
                        }}
                      >
                        서비스만족도조사
                      </button> */}
                    </div>

                  ) : (
                    ''

                  )}
                </div>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

BotMessage.propTypes = {
  boxStyle: PropTypes.object,
  responseType: PropTypes.string,
  item: PropTypes.object,
  index: PropTypes.number,
};

BotMessage.defaultProps = {
  boxStyle: {},
  item: {
    messageId: '',
    emotion: '',
    createAt: '2021.01.01 00:00',
    messages: [],
    templateMessages: [],
  },
  responseType: 'query',
  index: 0,
};

export default BotMessage;
